import * as tslib_1 from "tslib";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import TransferDialog from './TransferDialog.vue';
import { changeQuestionStatus, copyQuestion, getQuestionList, transferQuestion } from "@/api/question";
import { QUESTION_TYPE_MAP } from "../constant";
let QuestionTable = class QuestionTable extends Vue {
    constructor() {
        super(...arguments);
        this.pageIndex = 1;
        this.pageSize = 15;
        this.totalCount = 0;
        this.tableData = [];
        this.keyword = '';
        this.type = -1;
        this.hasShowTreeModal = false;
        this.selectedRows = [];
        this.btnLoading = false;
        this.currentRow = null;
        this.currentOperate = '';
        this.toLibraryId = '';
        this.toParentId = '';
        this.isPageInit = false;
        this.checkAllBox = false;
        this.isIndeterminate = false;
    }
    get imgIcon() {
        return require('@/assets/icon_pic.png');
    }
    get selectedRowsPos() {
        return this.selectedRows.reduce((acc, cur, idx) => {
            acc[cur.id] = idx;
            return acc;
        }, {});
    }
    get selectedRowsId() {
        return this.selectedRows.map((val) => {
            return val.id;
        });
    }
    get currentPageSelectedRows() {
        const selected = this.selectedRowsId;
        return this.tableData.filter((val) => {
            return selected.indexOf(val.id) > -1;
        });
    }
    get fakeTreeData() {
        return this.treeData.length > 0 && this.treeData[0].children || [];
    }
    get operateTitle() {
        var _map = {
            move: "转移",
            batchMove: "批量转移",
            copy: "复制",
            batchCopy: "批量复制"
        };
        return _map[this.currentOperate] || "";
    }
    handleQuestionLibraryIdChange(id) {
        if (!id)
            return;
        if (this.isPageInit) {
            this.pageIndex = 1;
        }
        else {
            this.pageIndex = Number(sessionStorage.getItem("questionPageIndex")) || 1;
            this.isPageInit = true;
        }
        // console.log("this.pageIndex", this.pageIndex)
        sessionStorage.setItem("questionPageIndex", `${this.pageIndex}`);
        this.selectedRows = [];
        this.getNewBankQesList();
    }
    created() {
        this.bindEvent();
    }
    // formatSvgTopic(e) {
    //   var t = document.createElement("div")
    //     , n = document.createElement("div");
    //   n.innerHTML = e.content;
    //   var r = n.querySelector("svg")
    //     , i = "";
    //   r && (i = r.outerHTML),
    //     t.innerHTML = e.describ;
    //   var o = t.textContent;
    //   return {
    //     text: o || "",
    //     svg: i || ""
    //   }
    // }
    insulateImg(question) {
        if (!question.simpleContent) // question.describ
            return question.content ? "[图片]" : "[音频]";
        // const imgRegExp = /<img\b[^>]*src[="'\s]+[^.]*\/([^.]+)\.[^"']+["']?[^>]*>/g
        // // const audioRegExp = /<iframe(.*?)class="xiaoe-iframe-audio"(.*?)>/g
        // // const videoRegExp = /<iframe(.*?)class="xiaoe-iframe-video"(.*?)>/g
        // const invalidImagRegExp = /<(?!img).*?>/g
        // // let o = question.describ.replace(imgRegExp, "");
        // // o = o.replace(audioRegExp, "[音频] ").replace(videoRegExp, "[视频]").replace(invalidImagRegExp, "")
        // // question.describ
        // return question.simpleContent.replace(imgRegExp, "").replace(invalidImagRegExp, "")
        // 后端已经把所有html标签都移除了
        return question.simpleContent;
    }
    bindEvent() {
        this.$bus.$on("active-search", this.search);
        this.$bus.$on("send-ques-type", this.getQuesType);
        this.$bus.$on("refresh-table", this.getNewBankQesList);
        this.$bus.$on("change-keyword", this.syncKeyword);
    }
    syncKeyword(keyword) {
        this.keyword = keyword;
    }
    async getNewBankQesList(params = {}) {
        params = Object.assign({
            categoryId: this.questionLibraryId !== '0' ? this.questionLibraryId : void 0,
            content: this.keyword ? this.keyword : void 0,
            type: this.type !== -1 ? this.type : void 0,
            pageNo: this.pageIndex,
            pageSize: this.pageSize
        }, params);
        // this.$store.commit("setGlobalLoading", true)
        try {
            const res = await getQuestionList(params);
            const data = res.data.data;
            this.totalCount = Number(data.total);
            this.tableData = data.list || [];
            if (this.currentPageSelectedRows.length > 0) {
                this.$nextTick(() => {
                    const tableEl = this.quesTable;
                    if (tableEl) {
                        // var data = e.getTable();
                        this.currentPageSelectedRows.forEach((e) => {
                            tableEl.toggleRowSelection(e, true);
                        });
                    }
                    const length = this.currentPageSelectedRows.length;
                    this.checkAllBox = length === this.tableData.length;
                    this.isIndeterminate = !this.checkAllBox && 0 !== length;
                });
            }
            else {
                this.isIndeterminate = false;
                this.checkAllBox = false;
            }
        }
        catch (error) {
            console.error(error);
        }
        finally {
            // this.$store.commit("setGlobalLoading", false)
        }
    }
    async activateQuestion(idList) {
        // this.$store.commit("setGlobalLoading", true)
        try {
            await changeQuestionStatus(idList, 1);
            this.selectedRows = [];
            this.getNewBankQesList();
        }
        catch (_) { }
        finally {
            // this.$store.commit("setGlobalLoading", false)
        }
    }
    async batchDeactivateQuestion(idList) {
        // this.$store.commit("setGlobalLoading", true)
        try {
            await changeQuestionStatus(idList, 0);
            // this.pageIndex = 1
            // sessionStorage.setItem("questionPageIndex", `${this.pageIndex}`)
            this.selectedRows = [];
            this.getNewBankQesList();
            // this.$bus.$emit("refresh-library-tree")
        }
        catch (error) {
            // this.$message.warning("题目不存在!")
        }
        finally {
            // this.$store.commit("setGlobalLoading", false)
        }
    }
    async batchTransferQuestion(data) {
        const { type } = data;
        // console.log("params", data)
        // if (type.indexOf("cut") >= 0) {
        //   try {
        //     await this.handleTransferCheckPracticeRelated(data)
        //   } catch (error) {
        //     return this.transferDialog.btnLoading = false
        //   }
        // }
        const handlers = {
            copy: copyQuestion,
            cut: transferQuestion
        };
        const handler = handlers[type];
        if (!handler)
            return;
        const { idList, newQuestionLibraryId } = data;
        try {
            this.btnLoading = true;
            await handler(idList, newQuestionLibraryId);
            this.pageIndex = 1;
            sessionStorage.setItem("questionPageIndex", `${this.pageIndex}`);
            this.selectedRows = [];
            if ("copy" !== type) {
                localStorage.setItem("questionLibraryId", data.newQuestionLibraryId);
            }
            this.getNewBankQesList();
            this.$bus.$emit("refresh-library-tree");
        }
        catch (error) {
        }
        finally {
            this.btnLoading = false;
            this.hasShowTreeModal = false;
        }
    }
    hasSvg(content) {
        const reg = /\<svg\s?.*(\>|\/\>)/g;
        return reg.test(content);
    }
    hasImage(content) {
        const reg = /<img\b[^>]*src[="'\s]+[^.]*\/([^.]+)\.[^"']+["']?[^>]*>/g;
        return reg.test(content);
    }
    edit(question) {
        // if (question.referenceCount > 0) {
        //   return this.$alert('该题目已被引用，如需编辑，请先解除关系', '编辑提示', {
        //     type: "info",
        //     confirmButtonText: '知道了',
        //     showCancelButton: false,
        //   })
        // }
        this.$router.push({
            name: question.type === 6 ? 'MaterialQuestionEdit' : 'QuestionEdit',
            query: {
                type: `${question.type}`,
                is_edit: '1',
                question_id: question.id
            }
        });
    }
    preview(question) {
        if (!question || !question.id)
            throw Error("缺少题目id，请检查！");
        this.$emit("preview", question.id);
    }
    async handleActivate(data) {
        const { idList } = data;
        try {
            await this.$confirm("请谨慎操作。", {
                type: "warning",
                title: "确认启用该题目吗？",
                cancelButtonText: "取消",
                confirmButtonText: "启用",
                confirmButtonClass: "confirm-cancel-button",
            });
            return this.activateQuestion(idList);
        }
        catch (_) { }
    }
    async handleDeactivate(data) {
        const { idList, hasBatch, hasRel } = data;
        if (hasRel) {
            return this.handleDeleteExamReleatedConfirm({
                idList,
                hasBatch,
                hasRel,
            });
        }
        try {
            await this.$confirm("停用后可重新启用。", {
                type: "warning",
                title: hasBatch && idList.length >= 2 ? `确认停用选中的${idList.length}个题目吗？` : "确认停用该题目吗？",
                cancelButtonText: "取消",
                confirmButtonText: "停用",
                confirmButtonClass: "confirm-cancel-button",
            });
            return this.batchDeactivateQuestion(idList);
        }
        catch (_) { }
    }
    changePage(pageIndex) {
        this.pageIndex = pageIndex;
        sessionStorage.setItem("questionPageIndex", `${pageIndex}`);
        const params = {
            pageNo: pageIndex
        };
        this.getNewBankQesList(params);
    }
    search(keyword) {
        this.keyword = keyword,
            this.changePage(1);
    }
    getQuesType(type) {
        this.type = Number(type),
            this.changePage(1);
    }
    getImg(content) {
        var result = [];
        const imgRegExp = /<img\b[^>]+src=['"]([^'"]+)['"]+/g;
        while (null != (result = imgRegExp.exec(content)))
            return result[1];
    }
    handleSelect(selection, row) {
        const length = selection.length;
        this.checkAllBox = length === this.tableData.length;
        this.isIndeterminate = !this.checkAllBox && 0 !== length;
        if (this.selectedRowsId.indexOf(row.id) > -1) {
            const index = this.selectedRowsPos[row.id];
            this.selectedRows.splice(index, 1);
        }
        else {
            this.selectedRows.push(row);
        }
    }
    handleSelectAll(selection) {
        const length = selection.length;
        if (length > 0) {
            const unselectedRows = selection.filter(row => -1 === this.selectedRowsId.indexOf(row.id));
            this.selectedRows = this.selectedRows.concat(unselectedRows);
        }
        else {
            const selectedRowsId = this.currentPageSelectedRows.map(row => row.id);
            selectedRowsId.forEach((id) => {
                const index = this.selectedRowsPos[id];
                this.selectedRows.splice(index, 1);
            });
        }
        this.checkAllBox = length === this.tableData.length;
        this.isIndeterminate = !this.checkAllBox && 0 !== length;
    }
    handleTreeNodeClick(data) {
        this.toParentId = data.parentId;
        this.toLibraryId = data.id;
    }
    handleOperateQuesPre(command, question) {
        this.currentOperate = command;
        const isBatch = command.includes("batch"), isDeactivate = command.toLowerCase().includes("deactivate"), isActivate = command.toLowerCase().includes("activate");
        if (isBatch && 0 === this.selectedRows.length) {
            this.$message.warning("请选择题目！");
        }
        else {
            this.currentRow = question || null;
            if (isDeactivate || isActivate) {
                this.handleOperateQues();
            }
            else {
                this.hasShowTreeModal = true;
            }
        }
    }
    handleOperateQues() {
        var payload = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
        const handlers = {
            move: this.batchTransferQuestion,
            batchMove: this.batchTransferQuestion,
            deactivate: this.handleDeactivate,
            batchDeactivate: this.handleDeactivate,
            copy: this.batchTransferQuestion,
            batchCopy: this.batchTransferQuestion,
            activate: this.handleActivate
        };
        const command = this.currentOperate.toLowerCase();
        const isCopy = command.includes("copy");
        const isMove = command.includes("move");
        const isBatch = command.includes("batch");
        const isDeactivate = command.includes("deactivate");
        const handler = handlers[this.currentOperate];
        let data = {
            idList: isBatch ? this.selectedRowsId : [this.currentRow.id]
        };
        if (isMove || isCopy) {
            data.type = isMove ? "cut" : isCopy ? "copy" : "";
            data.newQuestionLibraryId = this.toLibraryId;
        }
        if (isDeactivate) {
            let hasRelated = false;
            if (isBatch) {
                hasRelated = this.selectedRows.some((row) => {
                    return row.referenceCount > 0;
                });
            }
            else {
                hasRelated = this.currentRow.referenceCount > 0;
            }
            data = {
                ...data,
                hasBatch: isBatch,
                hasRel: hasRelated
            };
        }
        if (payload) {
            data.transferCallbackPayload = payload;
        }
        handler && handler(data);
    }
    handleDeleteExamReleatedConfirm(data) {
        const { hasBatch } = data;
        const text = hasBatch ? '存在已被引用的题目，无法批量停用' : '该题目已被引用，如需停用，请先解除关系';
        this.$alert(text, '停用提示', {
            type: "info",
            confirmButtonText: '知道了',
            showCancelButton: false,
        });
    }
    sizeChange(pageSize) {
        this.pageSize = pageSize;
        this.pageIndex = 1;
        const params = {
            pageNo: 1
        };
        this.getNewBankQesList(params);
    }
    handleCheckAllChange(checked) {
        const tableData = checked ? this.tableData : [];
        this.handleSelectAll(tableData);
        if (!tableData.length)
            this.checkAllBox = false;
        const tableEl = this.quesTable;
        if (checked) {
            tableData.forEach((row) => {
                tableEl.toggleRowSelection(row, true);
            });
        }
        else {
            tableEl.clearSelection();
        }
        this.isIndeterminate = false;
    }
};
tslib_1.__decorate([
    Prop({ type: Array, default: () => [] })
], QuestionTable.prototype, "treeData", void 0);
tslib_1.__decorate([
    Prop({ required: true })
], QuestionTable.prototype, "treeNodeMap", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], QuestionTable.prototype, "questionLibraryId", void 0);
tslib_1.__decorate([
    Prop({ type: Number, default: 0 })
], QuestionTable.prototype, "maxHeight", void 0);
tslib_1.__decorate([
    Ref()
], QuestionTable.prototype, "quesTable", void 0);
tslib_1.__decorate([
    Watch('questionLibraryId', { immediate: true })
], QuestionTable.prototype, "handleQuestionLibraryIdChange", null);
QuestionTable = tslib_1.__decorate([
    Component({
        name: "QuestionTable",
        components: {
            TransferDialog
        },
        filters: {
            mapQuestionType(id) {
                const type = QUESTION_TYPE_MAP.find((type) => {
                    return type.id === Number(id);
                });
                return type && type.text || "";
            }
        },
    })
], QuestionTable);
export default QuestionTable;
